// extracted by mini-css-extract-plugin
module.exports = {"screen":"Util_screen__2b7aU","icons":"Util_icons__3KiuN"};